import { Box, Button, Container, Typography } from "@mui/material";
import { FC } from "react";
import logoUrl from "../../assets/orgiggly-logo.svg";

/**
 * Graceful fallback when resolving/loading a site URL fails for a reason that
 * is likely transient (most commonly an anon-auth `auth/too-many-requests`
 * under load) rather than a genuine 404. Distinct from `OrgNotFound`: the org
 * probably exists, so we offer a retry instead of telling the user it's gone.
 */
export const SiteLoadError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      bgcolor: "background.default",
      color: "text.primary",
      p: 2,
    }}
  >
    <Container maxWidth="sm" sx={{ textAlign: "center" }}>
      <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
        <img src={logoUrl} alt="Orgiggly" style={{ height: 100 }} />
      </Box>
      <Typography variant="h5" gutterBottom>
        We couldn&apos;t load this page
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        This is usually temporary. Please try again in a moment.
      </Typography>
      <Button variant="contained" onClick={onRetry}>
        Try again
      </Button>
    </Container>
  </Box>
);

export default SiteLoadError;
